// Stub for @fortawesome/pro-thin-svg-icons
// Provides empty fat export to prevent errors
export const fat = {
  prefix: 'fat',
  iconName: 'stub',
  icon: [0, 0, [], '', '']
};
